// extracted by css-extract-rspack-plugin
export default {"HeadlineImage":"HeadlineImage-a6DvWj","headlineImage":"HeadlineImage-a6DvWj"};